export const weekOverviewPresenceOptions = Object.freeze({
  PRESENT: 'present',
  VACATION: 'vacation',
  SICK: 'sick',
});
